import { render, staticRenderFns } from "./AddBuyer.vue?vue&type=template&id=0cd01370&scoped=true&"
import script from "./AddBuyer.vue?vue&type=script&lang=js&"
export * from "./AddBuyer.vue?vue&type=script&lang=js&"
import style0 from "./AddBuyer.vue?vue&type=style&index=0&id=0cd01370&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd01370",
  null
  
)

export default component.exports